import BaseService from 'services/BaseService';

export default class EmailNotificationService extends BaseService {
	_type = 'email-notification';
	_typeKey = 'template_machine_name';
}
